import React, { useState } from "react";
import SideNav from "../components/SideNav/SideNav.component";
import Menu from "../components/Menu/Menu.component";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { ReactNotifications } from "react-notifications-component";

const withHeaderPages = (location) => {
  switch (location.pathname) {
    case "/login":
      return false;
    case "/privacy-policy":
      return false;
    case "/mechanics":
      return false;
    default:
      return true;
  }
};

const theme = createTheme({
  components: {
    MuiTableCell: {
      styleOverrides: {
        root: {
          fontSize: "1.3rem",
          fontFamily: "Noto Sans Display, sans-serif",
        },
        head: {
          backgroundColor: "rgb(21, 101, 192)",
          color: "#fff",
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          fontSize: "1.3rem",
          color: "#0e153a",
          textDecoration: "none",
          border: "none",
          fontFamily: "Noto Sans Display, sans-serif",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        notchedOutline: {
          border: 0,
          borderBottom: "1px solid #808080",
        },
        input: {
          padding: "1.1rem",
          color: "#000",
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          fontSize: "1.3rem",
          fontFamily: "Noto Sans Display, sans-serif",
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          padding: ".5rem",
        },
        listbox: {
          fontSize: "1.3rem",
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            padding: ".4rem",
          },
        },
      },
    },
    MuiSnackbar: {
      styleOverrides: {
        root: {
          bottom: "45px !important",
          right: "0 !important",
          justifyContent: "center !important",
          zIndex: "2",
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          fontSize: "1.3rem",
          fontFamily: "Noto Sans Display, sans-serif",
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: "Noto Sans Display, sans-serif",
          color: "#000",
          fontSize: "1.3rem",
        },
        h4: {
          fontSize: "1.8rem",
        },
        h5: {
          fontSize: "1.6rem",
        },
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          fontSize: "1.6rem",
        },
      },
    },
    MuiStepIcon: {
      styleOverrides: {
        text: {
          fontSize: "1.4rem",
        },
      },
    },
    MuiStepLabel: {
      styleOverrides: {
        label: {
          fontSize: "1.3rem",
        },
      },
    },
    MuiStepper: {
      styleOverrides: {
        root: {
          marginBottom: "2rem",
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          padding: "0",
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          overflowY: "visible",
        },
      },
    },
    MuiDialogContentText: {
      styleOverrides: {
        root: {
          color: "#000",
          fontSize: "1.3rem",
        },
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          overflowY: "visible",
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          fontSize: "1.3rem",
        },
      },
    },
    MuiTablePagination: {
      styleOverrides: {
        select: {
          fontSize: "1.1rem !important",
        },
        selectLabel: {
          fontSize: "1.1rem",
        },
        displayedRows: {
          fontSize: "1.1rem",
        },
      },
    },
    MuiPickersDay: {
      styleOverrides: {
        root: {
          fontSize: "1.3rem",
        },
      },
    },
    MuiPickersYear: {
      styleOverrides: {
        yearButton: {
          fontSize: "1.3rem",
        },
      },
    },
    MuiPickersCalendarHeader: {
      styleOverrides: {
        label: {
          fontSize: "1.3rem",
        },
      },
    },
    MuiDayCalendar: {
      styleOverrides: {
        weekDayLabel: {
          fontSize: "1.3rem",
        },
      },
    },
    MuiCardMedia: {
      styleOverrides: {
        root: {
          backgroundSize: "contain",
        },
      },
    },
    MuiTabPanel: {
      styleOverrides: {
        root: {
          padding: "10px",
        },
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: "5px 20px 0px 20px !important",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontSize: "1.2rem",
          fontFamily: "Noto Sans Display, sans-serif",
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        select: {
          minHeight: "1.60rem !important",
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        message: {
          fontSize: "1.3rem",
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          fontSize: "1.3rem",
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontSize: "1.3rem",
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          fontSize: "1.3rem",
        },
      },
    },
    MuiFab: {
      styleOverrides: {
        root: {
          zIndex: "3",
        },
      },
    },
    MuiPickersMonth: {
      styleOverrides: {
        monthButton: {
          fontSize: "1.3rem",
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontFamily: "Noto Sans Display, sans-serif",
          fontSize: "1.3rem",
        },
      },
    },
    MuiTableSortLabel: {
      styleOverrides: {
        root: {
          color: "#fff !important",
        },
        iconDirectionAsc: {
          color: "#fff !important",
        },
        icon: {
          opacity: 1,
          color: "#fff !important",
        },
      },
    },
  },
});

const Layout = ({ children, location, auth }) => {
  const Header = withHeaderPages(location);
  const [open, setOpen] = useState(true);

  const handleToggleOpen = (newOpen) => {
    setOpen(newOpen);
  };

  return (
    <ThemeProvider theme={theme}>
      <ReactNotifications />
      <div className={open ? "container open" : "container closed"}>
        <div
          className={open ? "container__item open" : "container__item closed"}
        >
          {Header && auth && (
            <header>
              <SideNav auth={auth} onToggleOpen={handleToggleOpen} />
            </header>
          )}
        </div>
        <div className="container__item">
          {Header && auth && (
            <header>
              <Menu location={location} auth={auth} />
            </header>
          )}
          <main className={Header ? "Main" : null}>{children}</main>
        </div>
      </div>
    </ThemeProvider>
  );
};

export default Layout;
